import styled from '@emotion/styled';

interface IBannerWidgetInnerProps {
  data: any;
}

interface IBannerBulletListProps {
  styles: any;
}

interface IBannerBannerButtonProps {
  styles: any;
  href?: string;
}

interface IBannerHeaderProps {
  styles: any;
}

export const BannerHeader = styled.h2`
  font-size: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.fontSize};
  line-height: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.lineHeight};
  text-align: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.textAlign};
  margin-bottom: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.marginBottom};
  img {
    width: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.logoWidth};
  }
  @media screen and (min-width:768px) and (max-width:999px) {
    font-size: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.IpadfontSize};
    line-height: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.IpadlineHeight};
    img {
      width: ${(props: IBannerHeaderProps) => props.styles?.bannerHeaderStyle?.IpadlogoWidth};
    }
  }
`

export const BannerWidgetContainer = styled.div`
  padding: 30px 0;
  border-bottom: 8px solid #F6F6F6;
  @media screen and (max-width:767px) {
    padding: 0;
  }
`;

export const BannerWidgetInner = styled.div`
  .contentwrapper {
    padding: 20px 0;
    background-color: ${(props: IBannerWidgetInnerProps) =>
    props.data?.background};
    @media screen and (max-width:999px) and (min-width:768px) {
      padding: 20px 16px;
    }
    @media screen and (max-width:767px) {
      padding: 32px 16px;
    }
  }
`;

export const BulletList = styled.div`
  margin-bottom: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.marginBottom};
  li {
    font-size: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.fontSize};
    line-height: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.lineHeight};
    color: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.color};
    padding-left: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.paddingLeft};
    text-decoration: none;
    +li {
      margin-top: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.marginTop};
    }
    @media screen and (max-width:1420px) {
      font-size: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.DesktopfontSize};
      line-height: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.DesktoplineHeight};
    }
  }
`;

export const BulletListMobile = styled.div`
  margin-bottom: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.marginBottom};
  li {
    font-size: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.fontSize};
    line-height: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.lineHeight};
    color: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.color};
    background: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.background};
    padding-left: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.paddingLeft};

    +li {
      margin-top: ${(props: IBannerBulletListProps) => props.styles?.bulletListStyle?.marginTop};
    }
  }
`;

export const BannerButton = styled.a`
  display: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.display};
  font-size: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.fontSize};
  line-height: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.lineHeight};
  font-weight: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.fontWeight};
  padding: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.padding};
  color: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.color};
  background: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.background};
  border: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.border};
  border-radius: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.borderRadius};
  margin-top: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.marginTop};

  @media screen and (min-width:768px) and (max-width:999px) {
    font-size: ${(props: IBannerBulletListProps) => props.styles?.bannerButtonStyle?.IpadfontSize};
  }
`;

export const BannerButtonWrapper = styled.div`
  text-align: ${(props: IBannerBannerButtonProps) => props.styles?.bannerButtonStyle?.textAlign};
`;
